/* lg-lightbox.js - Block 77 (4 Sep). Fitted lightbox for the PDP media modal.

   Dawn's product-modal shows every media item stacked in a scrolling column on
   desktop (section-main-product.css:646 sets display:block on non-active items
   at >=750px) and only the active one on mobile (:636 display:none). This
   turns both into a one-at-a-time fitted viewer with prev/next, a counter,
   arrow keys and swipe.

   assets/product-modal.js is NOT touched. The modal is a ModalDialog, whose
   show() sets the open attribute (global.js:631) - that attribute is the open
   signal this observes. Dawn marks the active item with .active in
   showActiveMedia(), which is read on open and then maintained here.

   Visibility is toggled with a class; nodes are never removed, so Dawn's own
   showActiveMedia() and any deferred-media loading still see the full list. */
(function () {
  'use strict';

  var FLAG = 'data-lg-lightbox';
  var HIDDEN = 'lg-lightbox__hidden';

  function setup(modal) {
    if (modal.getAttribute(FLAG) === '1') return; // already wired
    var content = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!content || !dialog) return;
    modal.setAttribute(FLAG, '1');

    var index = 0;
    var prev = null;
    var next = null;
    var counter = null;

    function items() {
      return Array.prototype.filter.call(content.children, function (el) {
        return el.hasAttribute && el.hasAttribute('data-media-id');
      });
    }

    function isOpen() {
      return modal.hasAttribute('open');
    }

    function build() {
      if (prev) return;
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'lg-lightbox__prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = '&#8249;';

      next = document.createElement('button');
      next.type = 'button';
      next.className = 'lg-lightbox__next';
      next.setAttribute('aria-label', 'Next image');
      next.innerHTML = '&#8250;';

      counter = document.createElement('span');
      counter.className = 'lg-lightbox__counter';
      counter.setAttribute('aria-live', 'polite');

      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });

      // global.js:609 closes any .media-modal on a mouse pointerup whose target
      // is not inside deferred-media/product-model. pointerup fires BEFORE click,
      // so stopping it here is the only thing that keeps the modal open -
      // preventDefault on the click handler above runs far too late.
      ['pointerdown', 'pointerup'].forEach(function (type) {
        [prev, next, counter].forEach(function (el) {
          el.addEventListener(type, function (e) { e.stopPropagation(); });
        });
      });

      dialog.appendChild(prev);
      dialog.appendChild(next);
      dialog.appendChild(counter);
    }

    function render() {
      var list = items();
      if (!list.length) return;
      if (index < 0) index = list.length - 1;
      if (index >= list.length) index = 0;

      list.forEach(function (el, i) {
        var on = i === index;
        el.classList.toggle('active', on);
        el.classList.toggle(HIDDEN, !on);
      });

      modal.setAttribute('data-lg-index', String(index + 1));
      modal.setAttribute('data-lg-total', String(list.length));
      if (counter) counter.textContent = index + 1 + ' / ' + list.length;

      var single = list.length < 2;
      if (prev) prev.hidden = single;
      if (next) next.hidden = single;
      if (counter) counter.hidden = single;
    }

    function step(delta) {
      index += delta;
      render();
    }

    function sync() {
      var list = items();
      if (!list.length) return;
      // Dawn has just set .active from the thumbnail that opened the modal.
      var active = list.indexOf(content.querySelector('.active'));
      index = active > -1 ? active : 0;
      build();
      modal.classList.add('lg-lightbox');
      render();
    }

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    var startX = null;
    content.addEventListener('touchstart', function (e) {
      startX = e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientX : null;
    }, { passive: true });
    content.addEventListener('touchend', function (e) {
      if (startX === null || !e.changedTouches || !e.changedTouches.length) return;
      var delta = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(delta) > 40) step(delta < 0 ? 1 : -1);
    }, { passive: true });

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (isOpen()) sync();
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }

    if (isOpen()) sync(); // already open (deep link / re-init)
  }

  function init() {
    var modals = document.querySelectorAll('product-modal');
    Array.prototype.forEach.call(modals, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
